// Login
export const LOGIN_PAGE_SHOW_LOGIN_FORM = 'LOGIN_PAGE_SHOW_LOGIN_FORM';
export const RESET_LOGIN_PAGE = 'RESET_LOGIN_PAGE';
export const UPDATE_LOGIN_PAGE_FORM_FIELD = 'UPDATE_LOGIN_PAGE_FORM_FIELD';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';

// PAYMENT
export const GET_TRANSACTION_CB_JR_UPG_PAGE_REQUEST = 'GET_TRANSACTION_CB_JR_UPG_PAGE_REQUEST';
export const GET_TRANSACTION_CB_JR_UPG_PAGE_ERROR = 'GET_TRANSACTION_CB_JR_UPG_PAGE_ERROR';
export const GET_TRANSACTION_CB_JR_UPG_PAGE_SUCCESS = 'GET_TRANSACTION_CB_JR_UPG_PAGE_SUCCESS';
export const RESET_CB_JR_UPG_PAGE_META = 'RESET_CB_JR_UPG_PAGE_META';
export const RESET_CB_JR_UPG_PAGE = 'RESET_CB_JR_UPG_PAGE';
export const GET_TRANSACTION_CB_JSUP_PAGE_REQUEST = 'GET_TRANSACTION_CB_JSUP_PAGE_REQUEST';
export const GET_TRANSACTION_CB_JSUP_PAGE_ERROR = 'GET_TRANSACTION_CB_JSUP_PAGE_ERROR';
export const GET_TRANSACTION_CB_JSUP_PAGE_SUCCESS = 'GET_TRANSACTION_CB_JSUP_PAGE_SUCCESS';
export const RESET_CB_JSUP_PAGE_META = 'RESET_CB_JSUP_PAGE_META';
export const RESET_CB_JSUP_PAGE = 'RESET_CB_JSUP_PAGE';

// PAYMENT METHOD
export const GET_PAYMENT_METHOD_REQUEST = 'GET_PAYMENT_METHOD_REQUEST';
export const GET_PAYMENT_METHOD_ERROR = 'GET_PAYMENT_METHOD_ERROR';
export const GET_PAYMENT_METHOD_SUCCESS = 'GET_PAYMENT_METHOD_SUCCESS';

// TICKETS
export const GET_TICKETS_PAGE_REQUEST = 'GET_TICKETS_PAGE_REQUEST';
export const GET_TICKETS_PAGE_ERROR = 'GET_TICKETS_PAGE_ERROR';
export const GET_TICKETS_PAGE_SUCCESS = 'GET_TICKETS_PAGE_SUCCESS';
export const GET_TICKETS_PAGE_LAUNDRY_ROOMS_REQUEST = 'GET_TICKETS_PAGE_LAUNDRY_ROOMS_REQUEST';
export const GET_TICKETS_PAGE_LAUNDRY_ROOMS_ERROR = 'GET_TICKETS_PAGE_LAUNDRY_ROOMS_ERROR';
export const GET_TICKETS_PAGE_LAUNDRY_ROOMS_SUCCESS = 'GET_TICKETS_PAGE_LAUNDRY_ROOMS_SUCCESS';
export const GET_PAYMENT_METHODS_REQUEST = 'GET_PAYMENT_METHODS_REQUEST';
export const GET_PAYMENT_METHODS_ERROR = 'GET_PAYMENT_METHODS_ERROR';
export const GET_PAYMENT_METHODS_SUCCESS = 'GET_PAYMENT_METHODS_SUCCESS';
export const SUBMIT_TICKET_PAGE_REQUEST = 'SUBMIT_TICKET_PAGE_REQUEST';
export const SUBMIT_TICKET_PAGE_ERROR = 'SUBMIT_TICKET_PAGE_ERROR';
export const SUBMIT_TICKET_PAGE_SUCCESS = 'SUBMIT_TICKET_PAGE_SUCCESS';
export const RESET_TICKETS_PAGE_META = 'RESET_TICKETS_PAGE_META';
export const RESET_TICKETS_PAGE = 'RESET_TICKETS_PAGE';

// TICKETS PAGE CALLBACK HACK
export const GET_TICKETS_PAGE_CALLBACK_FROM_JRUPG = 'GET_TICKETS_PAGE_CALLBACK_FROM_JRUPG';

// TICKET PAGE
export const GET_TICKET_DETAIL_PAGE_REQUEST = 'GET_TICKET_DETAIL_PAGE_REQUEST';
export const GET_TICKET_DETAIL_PAGE_ERROR = 'GET_TICKET_DETAIL_PAGE_ERROR';
export const GET_TICKET_DETAIL_PAGE_SUCCESS = 'GET_TICKET_DETAIL_PAGE_SUCCESS';
export const GET_TICKET_DETAIL_LAUNDRY_ROOMS_REQUEST = 'GET_TICKET_DETAIL_LAUNDRY_ROOMS_REQUEST';
export const GET_TICKET_DETAIL_LAUNDRY_ROOMS_ERROR = 'GET_TICKET_DETAIL_LAUNDRY_ROOMS_ERROR';
export const GET_TICKET_DETAIL_LAUNDRY_ROOMS_SUCCESS = 'GET_TICKET_DETAIL_LAUNDRY_ROOMS_SUCCESS';
export const SUBMIT_TICKET_DETAIL_LAUNDRY_ROOM_REQUEST = 'SUBMIT_TICKET_DETAIL_LAUNDRY_ROOM_REQUEST';
export const SUBMIT_TICKET_DETAIL_LAUNDRY_ROOM_ERROR = 'SUBMIT_TICKET_DETAIL_LAUNDRY_ROOM_ERROR';
export const SUBMIT_TICKET_DETAIL_LAUNDRY_ROOM_SUCCESS = 'SUBMIT_TICKET_DETAIL_LAUNDRY_ROOM_SUCCESS';
export const CANCEL_RESERVED_MACHINE_REQUEST = 'CANCEL_RESERVED_MACHINE_REQUEST';
export const CANCEL_RESERVED_MACHINE_ERROR = 'CANCEL_RESERVED_MACHINE_ERROR';
export const CANCEL_RESERVED_MACHINE_SUCCESS = 'CANCEL_RESERVED_MACHINE_SUCCESS';
export const RESET_TICKET_DETAIL_PAGE_META = 'RESET_TICKET_DETAIL_PAGE_META';
export const RESET_TICKET_DETAIL_PAGE = 'RESET_TICKET_DETAIL_PAGE';
export const GET_TICKETS_PAGE_LAUNDRY_ROOMS_MACHINES_REQUEST = 'GET_TICKETS_PAGE_LAUNDRY_ROOMS_MACHINES_REQUEST';
export const GET_TICKETS_PAGE_LAUNDRY_ROOMS_MACHINES_ERROR = 'GET_TICKETS_PAGE_LAUNDRY_ROOMS_MACHINES_ERROR';
export const GET_TICKETS_PAGE_LAUNDRY_ROOMS_MACHINES_SUCCESS = 'GET_TICKETS_PAGE_LAUNDRY_ROOMS_MACHINES_SUCCESS';

// RESERVE MACHINE PAGE
export const GET_RESERVE_TICKET_DETAIL_REQUEST = 'GET_RESERVE_TICKET_DETAIL_REQUEST';
export const GET_RESERVE_TICKET_DETAIL_ERROR = 'GET_RESERVE_TICKET_DETAIL_ERROR';
export const GET_RESERVE_TICKET_DETAIL_SUCCESS = 'GET_RESERVE_TICKET_DETAIL_SUCCESS';
export const GET_RESERVE_MACHINE_PAGE_REQUEST = 'GET_RESERVE_MACHINE_PAGE_REQUEST';
export const GET_RESERVE_MACHINE_PAGE_ERROR = 'GET_RESERVE_MACHINE_PAGE_ERROR';
export const GET_RESERVE_MACHINE_PAGE_SUCCESS = 'GET_RESERVE_MACHINE_PAGE_SUCCESS';
export const SUBMIT_RESERVE_MACHINE_PAGE_REQUEST = 'SUBMIT_RESERVE_MACHINE_PAGE_REQUEST';
export const SUBMIT_RESERVE_MACHINE_PAGE_ERROR = 'SUBMIT_RESERVE_MACHINE_PAGE_ERROR';
export const SUBMIT_RESERVE_MACHINE_PAGE_SUCCESS = 'SUBMIT_RESERVE_MACHINE_PAGE_SUCCESS';
export const RESET_RESERVE_MACHINE_PAGE_META = 'RESET_RESERVE_MACHINE_PAGE_META';
export const RESET_RESERVE_MACHINE_PAGE = 'RESET_RESERVE_MACHINE_PAGE';

// PURCHASE HISTORY
export const GET_PURCHASE_HISTORY_PAGE_REQUEST = 'GET_PURCHASE_HISTORY_PAGE_REQUEST';
export const GET_PURCHASE_HISTORY_PAGE_ERROR = 'GET_PURCHASE_HISTORY_PAGE_ERROR';
export const GET_PURCHASE_HISTORY_PAGE_SUCCESS = 'GET_PURCHASE_HISTORY_PAGE_SUCCESS';
export const RESET_PURCHASE_HISTORY_PAGE_META = 'RESET_PURCHASE_HISTORY_PAGE_META';
export const RESET_PURCHASE_HISTORY_PAGE = 'RESET_PURCHASE_HISTORY_PAGE';